/**
 * 提供 request 方法登录过期自动前往登录的能力
 * 1. 默认不开启（通过传入 hasAuth 参数控制）
 * @method auth
 * @param {Function} func request 方法
 * @return {Function} 包装后的 request 方法
 */

import { APP_API_UNAUTH_CODE } from '@/constants';
import { login } from '@/api/auth';

const auth = func => options => {
  const { hasAuth = false } = options;
 
  if (!hasAuth) return func(options);
 
  return func(options).catch(err => {
    if (err && err.code === APP_API_UNAUTH_CODE) {
      login(); // tips：登录过期则进行重新登录
      err.ignore = true; // tips：忽略页面上的 onerror
    };

    throw err;
  });
};
 
export default auth;
